import React from 'react';
import { useAuth } from '../context/AuthContext';
import { ShieldAlert, Loader2 } from 'lucide-react';

const GoogleIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
    <path d="M1 1h22v22H1z" fill="none" />
  </svg>
);

export const Login: React.FC = () => {
  const { login, error, loading } = useAuth();
  const getFriendlyErrorMessage = (errorMessage: string | null) => {
    if (!errorMessage) return null;
    if (errorMessage.includes('auth/configuration-not-found')) return "Configuration error.";
    if (errorMessage.includes('auth/popup-closed-by-user')) return "Sign-in was cancelled.";
    if (errorMessage.includes('auth/operation-not-allowed')) return "Google Sign-In is not enabled in Firebase Console.";
    if (errorMessage.includes('auth/unauthorized-access')) return "You are not allowed to use this app.";
    return errorMessage;
  };
  const friendlyError = getFriendlyErrorMessage(error);

  if (error && error.includes('auth/unauthorized-access')) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white p-4 text-center">
        <p className="text-gray-900 text-lg">you are not allowed to use this app</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-cover bg-center" style={{ backgroundImage: "url('/jungle-bg.png')" }}>
      <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl w-full max-w-md p-8 space-y-8">
        <div className="text-center">
          <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 overflow-hidden">
            <img src="/toucan-logo.png" alt="Toucan Logo" className="w-14 h-14 object-contain mix-blend-multiply scale-x-[-1]" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900">Exclusive messaging</h1>
          <p className="text-gray-500 mt-2">Zero patience for the alternatives.

            We built this one for us!</p>
        </div>
        {friendlyError && (
          <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-md flex items-start gap-3">
            <ShieldAlert className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
            <div className="text-sm text-red-700"><p>{friendlyError}</p></div>
          </div>
        )}
        <div className="space-y-6">
          <button onClick={() => login()} disabled={loading} className="w-full flex items-center justify-center gap-3 bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 font-medium py-3 px-4 rounded-lg transition-all shadow-sm">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <><GoogleIcon /><span>Sign in with Google</span></>}
          </button>
        </div>
      </div>
    </div >
  );
};
